import { render, staticRenderFns } from "./ModalNovaAba.vue?vue&type=template&id=a9be45a0&"
import script from "./ModalNovaAba.vue?vue&type=script&lang=js&"
export * from "./ModalNovaAba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports